import React from 'react';
import {CollapseFilter} from 'components/partials/collapse';
import style from './style.scss';
import {Checkbox} from 'components/partials/checkbox';

class CheckBoxFilter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <section className="checkbox-filter">
        <CollapseFilter value={true} title='Màu sắc'>
          <div className='wrap-list-checkbox'>
            <Checkbox label='Red'/>
            <Checkbox label='Yellow'/>
            <Checkbox label='Blue'/>
            <Checkbox label='Green'/>
            <Checkbox label='Brown'/>
            <Checkbox label='Gray'/>
          </div>
          <p className='more-filter'><a className='item-link' href='/list-products/10'><span className='plush'>+</span> Xem thêm</a></p>
        </CollapseFilter>
      </section>
    );
  }
}

export default CheckBoxFilter;


// WEBPACK FOOTER //
// ./components/list-product/list-filter/sub-filter/CheckBoxFilter.jsx